import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import AddEditPopup from "./addEditPopup";

/**
 * The collection editor on its own route.
 *
 * A collection is a curated, ordered shelf of books, so the editor needs the
 * room a grid of covers takes. The form is unchanged; `asPage` only swaps the
 * dialog chrome for a plain container.
 *
 * `/collections/new` creates, `/collections/:collectionId/edit` edits.
 */
const EditCollectionPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { collectionId } = useParams();
    const isEdit = Boolean(collectionId);

    // Back to the list exactly as it was left — its filters live in the URL —
    // or a bare list for a direct link that carries no state.
    const backToList = () => navigate(location.state?.returnTo || "/collections");

    return (
        <AddEditPopup
            asPage
            // These two drive the heading and which fields show, so they still
            // have to say which mode this is.
            isAddCollectionModalVisible={!isEdit}
            isEditCollectionModalVisible={isEdit}
            setIsAddCollectionModalVisible={() => {}}
            handleCloseModal={backToList}
            collectionId={collectionId ?? []}
            // The list refetches on mount, so closing is the only navigation.
            onSuccess={() => {}}
        />
    );
};

export default EditCollectionPage;
